import React, { useState, Component, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { Dropdown, Button } from "react-bootstrap";
import Calendar from "react-calendar";
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";

//import Images:
import avatar from "../../../images/avatar/1.jpg";
import avatar1 from "../../../images/avatar/2.jpg";
import avatar2 from "../../../images/avatar/3.jpg";
import { useAuth } from "../../../context/AuthContext";
import { db, storage } from "../../../firebase";
import {
  setDoc,
  getDoc,
  updateDoc,
  doc,
  getDocs,
  collection,
  where,
  query,
} from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import {
  notifyTopRight,
  notifyWarning,
  notifyError,
} from "../../components/toast/SetToast";
import Toast from "../../components/toast/SetToast";
import PageTitle from "../../layouts/PageTitle";
import {
  getNodeCustomerAccess,
  isStaffCustomerScopedUser,
} from "../../../utils/staffCustomerAccess";
import { buildAccountCustomerAccessRows } from "./HomeCustomerAccess";

const PatientChart = loadable(() =>
  pMinDelay(import("../charts/doctor_details/PatientChart"), 1000),
);
const DoctorsAbility = loadable(() =>
  pMinDelay(import("../charts/doctor_details/DoctorsAbility"), 1000),
);

const Home = () => {
  const profileData = {
    firstname: null,
    lastname: null,
    username: null,
    email: null,
    node: [],
    position: null,
    photo: null,
    role: null,
  };

  const [isEditProfile, setEditProfile] = useState(false);
  const [isEditPassword, setEditPassword] = useState(false);
  const [isShowPassword, setShowPassword] = useState(false);

  const [profile, setProfile] = useState(profileData);
  const [fileUrl, setFileUrl] = useState(null);
  const [fileName, setFilename] = useState("Leave blank to keep the same");
  const [uuidfilename, setuuidFilename] = useState(null);
  const [nodesList, setNodesList] = useState([]);
  const [isAccountDataLoaded, setIsAccountDataLoaded] = useState(false);
  const {
    currentUser,
    updateUserPassword,
    updateUserEmail,
    updateUserdisplayName,
    updateUserPhoto,
  } = useAuth();
  const firstnameRef = useRef();
  const lastnameRef = useRef();
  const emailRef = useRef();
  const positionRef = useRef();
  const nodeRef = useRef();
  const roleRef = useRef();

  const passwordRef = useRef();
  const passwordConfirmRef = useRef();

  const selectedFileHandler = async (e) => {
    if (e.target.files[0] == null) return;
    //upload
    const tempfilename = `${uuidv4() + "-" + e.target.files[0].name}`;
    setuuidFilename(tempfilename);
    setFilename(e.target.files[0].name);
    const storageRef = ref(storage, `avatars/${tempfilename}`);
    await uploadBytes(storageRef, e.target.files[0])
      .then((sanpshot) => {
        console.log("File Uploaded!");
        getDownloadURL(sanpshot.ref).then((downloadURL) => {
          setFileUrl(downloadURL);
          console.log("File available at", downloadURL);
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleOnCancel = async () => {
    if (uuidfilename == null) {
      setEditProfile(false);
      return;
    }
    const photoRef = ref(storage, `avatars/${uuidfilename}`);
    await deleteObject(photoRef)
      .then(async () => {
        console.log("File Deleted !");
        setFileUrl(null);
      })
      .catch((error) => {
        console.log(error);
      });
    setFilename("");
    setEditProfile(false);
  };

  const handleOnClick = async (e) => {
    e.preventDefault();

    const docRef = doc(db, "admins", currentUser.displayName);
    const docSnap = await getDoc(docRef);
    if (emailRef.current.value !== currentUser.email) {
      await updateUserEmail(emailRef.current.value);
    }

    updateUserPhoto(fileUrl);

    const savedNodeCodes = Array.isArray(profile.node)
      ? profile.node
      : profile.node
        ? [profile.node]
        : [];

    let update = {
      firstname: firstnameRef.current.value,
      lastname: lastnameRef.current.value,
      email: emailRef.current.value,
      node: savedNodeCodes,
      position: positionRef.current.value,
    };

    // delete
    if (uuidfilename != null) {
      const photoRef = ref(storage, `avatars/${profile.photo}`);
      deleteObject(photoRef)
        .then(() => {
          console.log("File Deleted !");
          setuuidFilename(null);
          setFileUrl(null);
        })
        .catch((error) => {
          console.log(error);
        });
      update = { ...update, photo: uuidfilename };
    }

    if (docSnap.exists()) {
      await updateDoc(docRef, {
        ...update,
      });
    } else {
      await setDoc(docRef, {
        firstname: firstnameRef.current.value,
        lastname: lastnameRef.current.value,
        email: emailRef.current.value,
        node: savedNodeCodes,
        position: positionRef.current.value,

        photo: uuidfilename,
      });
    }
    notifyTopRight("Update success");
    setEditProfile(false);

    return;
  };

  const handleOnPasswordSubmit = () => {
    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      notifyError("Password do not match");
      return;
    }
    updateUserPassword(passwordRef.current.value)
      .then(() => notifyTopRight("Update password success"))
      .catch((err) => notifyError(err));
  };
  const getNodes = async (adminData = {}) => {
    const nodes = await getDocs(collection(db, "nodes"));
    const allNodes = nodes.docs.map((nodeDoc) => ({
      ...nodeDoc.data(),
      id: nodeDoc.id,
    }));
    const currentRoles = Array.isArray(currentUser.roles)
      ? currentUser.roles
      : [];

    if (
      currentRoles.includes("super_admin") ||
      currentRoles.includes("accountant")
    ) {
      setNodesList(allNodes);
    } else {
      const currentNodes = Array.isArray(adminData.node)
        ? adminData.node
        : adminData.node
          ? [adminData.node]
          : [];

      // Filter nodes based on the admin's node permissions.
      let userNodes = allNodes.filter((nodeInfo) =>
        currentNodes.includes(nodeInfo.nodecode),
      );

      if (isStaffCustomerScopedUser(currentUser)) {
        userNodes = await Promise.all(
          userNodes.map(async (nodeInfo) => {
            const customerAccess = getNodeCustomerAccess(
              adminData,
              nodeInfo.nodecode,
            );
            let customers = [];

            if (customerAccess.mode === "all") {
              const customerSnap = await getDocs(
                collection(db, "nodes", nodeInfo.id, "customers"),
              );
              customers = customerSnap.docs.map((customerDoc) => ({
                id: customerDoc.id,
                ...customerDoc.data(),
              }));
            } else if (customerAccess.mode === "selected") {
              const selectedCustomerDocs = await Promise.all(
                customerAccess.customerIds.map((customerId) =>
                  getDoc(
                    doc(
                      db,
                      "nodes",
                      nodeInfo.id,
                      "customers",
                      customerId,
                    ),
                  ),
                ),
              );
              customers = selectedCustomerDocs
                .filter((customerDoc) => customerDoc.exists())
                .map((customerDoc) => ({
                  id: customerDoc.id,
                  ...customerDoc.data(),
                }));
            }

            return {
              ...nodeInfo,
              customers,
            };
          }),
        );
      }

      setNodesList(userNodes);
    }
  };

  useEffect(() => {
    let isActive = true;

    const loadAccountData = async () => {
      try {
        const adminRef = doc(db, "admins", currentUser.displayName);
        const adminSnap = await getDoc(adminRef);
        let adminData = adminSnap.exists() ? adminSnap.data() : null;

        if (!adminData) {
          const queryRef = query(
            collection(db, "admins"),
            where("email", "==", currentUser.email),
          );
          const profileSnap = await getDocs(queryRef);
          adminData = profileSnap.empty ? {} : profileSnap.docs[0].data();
        }

        if (!isActive) return;
        setProfile(adminData);
        await getNodes(adminData);
      } catch (error) {
        console.error("Unable to load account profile:", error);
        if (isActive) notifyError("Unable to load account information");
      } finally {
        if (isActive) setIsAccountDataLoaded(true);
      }
    };

    loadAccountData();

    return () => {
      isActive = false;
    };
  }, []);

  const showCustomerAccess = isStaffCustomerScopedUser(currentUser);
  const customerAccessRows = showCustomerAccess
    ? buildAccountCustomerAccessRows(profile, nodesList)
    : [];

  return (
    <React.Fragment>
      <Toast />
      <PageTitle activeMenu="Your Account" motherMenu="Admin" motherLink="/" />
      <div className="form-head d-flex mb-3 mb-lg-5 align-items-start">
        <Button
          onClick={() => setEditProfile(!isEditProfile)}
          className={isEditProfile ? "btn btn-blue" : "btn btn-dark"}
        >
          <i className="flaticon-381-clock mr-2"></i>Edit Profile
        </Button>
      </div>
      <div className="col-lg-13">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-xl-8">
                <div className="form-group row">
                  <label
                    className="col-lg-3 col-form-label"
                    htmlFor="val-username"
                  >
                    Name
                  </label>
                  {isEditProfile ? (
                    <div className="col-lg-4">
                      <input
                        type="text"
                        className="form-control"
                        id="val-username"
                        name="val-username"
                        placeholder="First Name"
                        ref={firstnameRef}
                        defaultValue={profile.firstname}
                      />
                    </div>
                  ) : (
                    <div className="col-lg-2">
                      <label className="mt-2">{profile.firstname}</label>
                    </div>
                  )}

                  {isEditProfile ? (
                    <div className="col-lg-4">
                      <input
                        type="text"
                        className="form-control"
                        id="val-username"
                        name="val-username"
                        placeholder="Last Name"
                        ref={lastnameRef}
                        defaultValue={profile.lastname}
                      />
                    </div>
                  ) : (
                    <div className="col-lg-2">
                      <label className="mt-2">{profile.lastname}</label>
                    </div>
                  )}
                </div>

                <div className="form-group row">
                  <label
                    className="col-lg-3 col-form-label"
                    htmlFor="val-username"
                  >
                    Email
                  </label>

                  {isEditProfile ? (
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        id="val-username"
                        name="val-username"
                        placeholder="Email"
                        disabled
                        ref={emailRef}
                        defaultValue={profile.email}
                      />
                    </div>
                  ) : (
                    <div className="col-lg-4">
                      <label className="mt-2">{profile.email}</label>
                    </div>
                  )}
                </div>

                {isEditProfile ? (
                  <div className="form-group row">
                    <label
                      className="col-lg-3 col-form-label"
                      htmlFor="val-username"
                    >
                      Position
                    </label>
                    <div className="col-lg-3">
                      <select
                        className="form-control form-control-lg-2"
                        id="inlineFormCustomSelect"
                        ref={positionRef}
                        defaultValue={profile.position}
                      >
                        <option value="Administrator">Administrator</option>
                        <option value="SleepTechnician">
                          Sleep Technician
                        </option>
                        <option value="SleepPhysician">Sleep Physician</option>
                      </select>
                    </div>
                  </div>
                ) : (
                  <div className="form-group row">
                    <label
                      className="col-lg-3 col-form-label"
                      htmlFor="val-username"
                    >
                      Position
                    </label>
                    <div className="col-lg-4">
                      <label className="mt-2">
                        {currentUser.roles[0] == "sleep_physician"
                          ? "Sleep Physician"
                          : currentUser.roles[0] == "sleep_technician"
                            ? "Sleep Technician"
                            : "Administrator"}
                      </label>
                    </div>
                  </div>
                )}

                <div className="form-group row">
                  <label
                    className="col-lg-3 col-form-label"
                    htmlFor="val-username"
                  >
                    Node
                  </label>
                  <div className="col-lg-8">
                    {isEditProfile ? (
                      <select
                        className="form-control"
                        id="inlineFormCustomSelect"
                        ref={nodeRef}
                        defaultValue={profile.node} // Default multiple selected values
                        multiple
                        disabled // Prevents user from editing
                      >
                        {nodesList.map((doc) => (
                          <option key={doc.id} value={doc.nodecode}>
                            {doc.nodecode}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <div className="mt-2">
                        {Array.isArray(profile.node) ? (
                          profile.node.map((node, index) => (
                            <span
                              key={index}
                              className="badge badge-primary mr-2"
                            >
                              {node}
                            </span>
                          ))
                        ) : (
                          <label>{profile.node}</label>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {showCustomerAccess && (
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">
                      Customer Access
                    </label>
                    <div className="col-lg-8">
                      {!isAccountDataLoaded ? (
                        <div className="alert alert-light border mb-0 py-2">
                          <i className="fa fa-spinner fa-spin mr-2" />
                          Loading customer access...
                        </div>
                      ) : customerAccessRows.length === 0 ? (
                        <div className="alert alert-light border mb-0 py-2">
                          No assigned nodes or customers.
                        </div>
                      ) : (
                        customerAccessRows.map((accessRow) => (
                          <div
                            className="border rounded p-3 mb-2"
                            style={{ backgroundColor: "#f8f9fb" }}
                            key={accessRow.nodeCode}
                          >
                            <div className="d-flex flex-wrap align-items-center justify-content-between">
                              <div>
                                <strong>{accessRow.nodeName}</strong>
                                {accessRow.nodeCode && (
                                  <span className="badge badge-light border ml-2">
                                    {accessRow.nodeCode}
                                  </span>
                                )}
                              </div>
                              <span
                                className={`badge ${
                                  accessRow.mode === "all"
                                    ? "badge-success"
                                    : accessRow.mode === "selected"
                                      ? "badge-info"
                                      : "badge-secondary"
                                }`}
                              >
                                {accessRow.mode === "all"
                                  ? "All customers"
                                  : accessRow.mode === "selected"
                                    ? `${accessRow.customers.length} assigned`
                                    : "No customer access"}
                              </span>
                            </div>

                            {accessRow.isLegacyDefault && (
                              <small className="text-muted d-block mt-1">
                                Legacy account: access includes all customers
                                in this node.
                              </small>
                            )}

                            {accessRow.customers.length > 0 ? (
                              <div className="d-flex flex-wrap mt-2">
                                {accessRow.customers.map((customer) => (
                                  <div
                                    className="bg-white border rounded px-2 py-1 mr-2 mb-2"
                                    key={customer.id}
                                    style={{ maxWidth: "100%" }}
                                  >
                                    <div style={{ overflowWrap: "anywhere" }}>
                                      {customer.name}
                                    </div>
                                    {customer.name !== customer.id && (
                                      <small className="text-muted d-block">
                                        Customer ID: {customer.id}
                                      </small>
                                    )}
                                    {customer.isMissing && (
                                      <small className="text-warning d-block">
                                        Saved customer ID
                                      </small>
                                    )}
                                  </div>
                                ))}
                              </div>
                            ) : accessRow.mode === "all" ? (
                              <small className="text-muted d-block mt-2">
                                No customer records found under this node.
                              </small>
                            ) : accessRow.mode === "selected" ? (
                              <small className="text-muted d-block mt-2">
                                No assigned customer records found.
                              </small>
                            ) : null}
                          </div>
                        ))
                      )}
                      <small className="text-muted d-block mt-1">
                        Customer access is managed by an administrator and
                        cannot be changed from this page.
                      </small>
                    </div>
                  </div>
                )}

                <div className="form-group row">
                  <label
                    className="col-lg-3 col-form-label"
                    htmlFor="val-username"
                  >
                    Profile Image
                  </label>
                  {isEditProfile ? (
                    <div className="basic-form custom_file_input">
                      <div className="input-group mb-3">
                        <div className="input-group-prepend">
                          <span className="input-group-text">Upload</span>
                        </div>
                        <div className="custom-file">
                          <input
                            type="file"
                            className="custom-file-input"
                            onChange={selectedFileHandler}
                          />
                          <label className="custom-file-label">
                            {fileName}
                          </label>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      <label className="mt-2"></label>
                    </>
                  )}
                </div>

                {isEditProfile ? (
                  <div className="form-group row">
                    <label
                      className="col-lg-3 col-form-label"
                      htmlFor="val-username"
                    >
                      {/* Role */}
                    </label>
                    <div className="col-lg-8">
                      <button
                        type="submit"
                        className="btn btn-primary "
                        onClick={handleOnClick}
                      >
                        Submit
                      </button>
                      <button
                        type="submit"
                        className="btn btn-light ml-2 "
                        onClick={handleOnCancel}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="form-head d-flex mb-3 mb-lg-5 align-items-start">
        <Button
          onClick={() => setEditPassword(!isEditPassword)}
          className={isEditPassword ? "btn btn-blue" : "btn btn-dark"}
        >
          <i className="flaticon-381-clock mr-2"></i> Edit Password
        </Button>
      </div>
      <div className="col-lg-13">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-xl-8">
                {isEditPassword ? (
                  <>
                    <div className="form-group row">
                      <label
                        className="col-lg-3 col-form-label"
                        htmlFor="val-oldpassword"
                      >
                        New Password
                      </label>
                      <div className="col-lg-3">
                        <input
                          type="password"
                          className="form-control"
                          id="val-oldpassword"
                          name="val-oldpassword"
                          placeholder="Password"
                          ref={passwordRef}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label
                        className="col-lg-3 col-form-label"
                        htmlFor="val-newpassword"
                      >
                        Confirm New Password
                      </label>
                      <div className="col-lg-3">
                        <input
                          type="password"
                          className="form-control"
                          id="val-newpassword"
                          name="val-newpassword"
                          placeholder="Confirm Password"
                          ref={passwordConfirmRef}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="form-group row">
                    <label
                      className="col-lg-3 col-form-label"
                      htmlFor="val-newpassword"
                    >
                      Password
                    </label>
                    <div className="col-lg-3">
                      <label className="mt-2">**********</label>
                      <i></i>
                    </div>
                  </div>
                )}
                {isEditPassword ? (
                  <div className="form-group row">
                    <label
                      className="col-lg-3 col-form-label"
                      htmlFor="val-username"
                    >
                      {/* Role */}
                    </label>
                    <div className="col-lg-8">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        onClick={handleOnPasswordSubmit}
                      >
                        Submit
                      </button>
                      <button
                        type="submit"
                        className="btn btn-light ml-2 "
                        onClick={() => setEditPassword(false)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Home;
